const sizeToClassMap = {
  small: 'c-loading--small',
  large: 'c-loading--large',
};

export const LOADING_SIZES = Object.keys(sizeToClassMap);
export const LOADING_CLASS_MAP = {
  size: sizeToClassMap,
};
